export interface ChallengeItem {
  id: string;
  category: string;
  title: string;
  icon: string;
  region: string;
  requiredLevel: number;
  npcName: string;
  desc: string;
}

export const CHALLENGES_LIST: ChallengeItem[] = [
  // Niveau 0 - Taddart
  {
    id: 'animaux',
    category: 'Animaux',
    title: 'Animaux du Village',
    icon: '🐾',
    region: 'Taddart',
    requiredLevel: 0,
    npcName: 'Dda Sliman (Le Fermier)',
    desc: 'Bêtes du troupeau, oiseaux et faune des montagnes kabyles.'
  },
  {
    id: 'maison',
    category: 'La Maison',
    title: 'La Maison Ancestrale',
    icon: '🏠',
    region: 'Taddart',
    requiredLevel: 0,
    npcName: "Dda Muḥand (L'Artisan)",
    desc: 'Objets du quotidien, pièces et foyer familial (Axxam).'
  },
  {
    id: 'famille',
    category: 'La Famille',
    title: 'La Famille & Liens',
    icon: '👨‍👩‍👧',
    region: 'Taddart',
    requiredLevel: 0,
    npcName: 'La Tajmaɛt',
    desc: 'Membres de la famille, proches et termes affectueux.'
  },
  {
    id: 'salutations',
    category: 'Salutations & Politesse',
    title: 'Salutations & Politesse',
    icon: '👋',
    region: 'Taddart',
    requiredLevel: 0,
    npcName: "Na Nanna (L'Aînée)",
    desc: 'Formules de politesse, souhaits et accueil (Azul, Tanemmirt, Ansuf...).'
  },
  {
    id: 'pronoms',
    category: 'Pronoms & Personnes',
    title: 'Pronoms & Personnes',
    icon: '👤',
    region: 'Taddart',
    requiredLevel: 0,
    npcName: 'Amɣar n Taddart',
    desc: 'Pronoms personnels et identités (D nekk, D kečč, D netta...).'
  },
  {
    id: 'lieux',
    category: 'Lieux & Espace',
    title: 'Lieux & Géographie',
    icon: '🗺️',
    region: 'Tamurt',
    requiredLevel: 0,
    npcName: 'Les Anciens',
    desc: "Villes de Kabylie, orientations et repères dans l'espace."
  },

  // Niveau 1 - Azemmur
  {
    id: 'nature',
    category: 'Nature & Météo',
    title: 'Nature & Éléments',
    icon: '🌿',
    region: 'Azemmur',
    requiredLevel: 1,
    npcName: "Ɛemmi Ɛli (L'Agriculteur)",
    desc: 'Arbres, oliviers, rivières, météo et ciel.'
  },
  {
    id: 'nombres',
    category: 'Nombres & Quantité',
    title: 'Nombres & Mesures',
    icon: '🔢',
    region: 'Azemmur',
    requiredLevel: 1,
    npcName: 'Amesnuz (Le Marchand)',
    desc: 'Chiffres, comptage et mesures pour le commerce.'
  },
  {
    id: 'nourriture',
    category: 'Nourriture',
    title: 'Nourriture & Saveurs',
    icon: '🍯',
    region: 'Azemmur',
    requiredLevel: 1,
    npcName: 'Tajmaɛt n Uzemmur',
    desc: 'Plats kabyles, fruits, récoltes et saveurs traditionnelles.'
  },
  {
    id: 'questions',
    category: 'Questions & Réponses',
    title: 'Questions & Réponses',
    icon: '❓',
    region: 'Azemmur',
    requiredLevel: 1,
    npcName: 'Inebgi (Le Voyageur)',
    desc: 'Questions indispensables et réponses courantes (Amek, Anda, Ih, Ala...).'
  },
  {
    id: 'phrases',
    category: 'Phrases & Quotidien',
    title: 'Phrases & Quotidien',
    icon: '💬',
    region: 'Azemmur',
    requiredLevel: 1,
    npcName: 'Yidir (Le Jeune)',
    desc: 'Phrases complètes, échanges et expressions de la vie quotidienne.'
  },

  // Niveau 2 - Djurdjura
  {
    id: 'corps',
    category: 'Le Corps & Soins',
    title: 'Le Corps & Soins',
    icon: '🩺',
    region: 'Djurdjura',
    requiredLevel: 2,
    npcName: 'Aṭbib (Le Guérisseur)',
    desc: 'Anatomie, santé, hygiène et sensations physiques.'
  },
  {
    id: 'actions',
    category: 'Verbes',
    title: 'Verbes',
    icon: '🏃',
    region: 'Djurdjura',
    requiredLevel: 2,
    npcName: 'Aṣeggaḍ (Le Chasseur)',
    desc: 'Mouvements concrets, impératifs et verbes dynamiques du quotidien.'
  },
  {
    id: 'verbes_passe',
    category: 'Verbes au Passé',
    title: 'Verbes au Passé',
    icon: '🕰️',
    region: 'Djurdjura',
    requiredLevel: 2,
    npcName: 'Amezzuɣ (Le Gardien)',
    desc: 'Actions accomplies et conjugaisons au prétérit (Ččiɣ, Ruḥeɣ, Xedmeɣ...).'
  },
  {
    id: 'verbes_futur',
    category: 'Verbes au Futur & Présent',
    title: 'Verbes au Futur & Présent',
    icon: '⚡',
    region: 'Djurdjura',
    requiredLevel: 2,
    npcName: "Anelmad (L'Éclaireur)",
    desc: 'Projets, intentions et verbes avec particule (Ad ččeɣ, Ad nruḥ...).'
  },
  {
    id: 'pensee_comm',
    category: 'Pensée & Communication',
    title: 'Pensée & Communication',
    icon: '🗣️',
    region: 'Djurdjura',
    requiredLevel: 2,
    npcName: 'Bab n Wawal',
    desc: 'Écoute, parole, réflexion et certitudes (Mmeslay, Fhemeɣ, Ẓriɣ...).'
  },
  {
    id: 'transports',
    category: 'Jeux & Transports',
    title: 'Jeux & Voyages',
    icon: '🚗',
    region: 'Djurdjura',
    requiredLevel: 2,
    npcName: 'Les Voyageurs',
    desc: "Jeux d'enfants, véhicules et moyens de transport."
  },

  // Niveau 3 - Iɣil
  {
    id: 'emotions',
    category: 'Émotions & Sensations',
    title: 'Émotions & Sentiments',
    icon: '💜',
    region: 'Iɣil',
    requiredLevel: 3,
    npcName: 'Tamarguṭ (La Voyante)',
    desc: "Joie, peine, fierté, sentiments et états d'esprit."
  },
  {
    id: 'histoires',
    category: 'Histoires & École',
    title: 'Histoires & Savoir',
    icon: '📚',
    region: 'Iɣil',
    requiredLevel: 3,
    npcName: 'Amacahu (Le Conteur)',
    desc: 'Contes, proverbes, éducation et mémoire des anciens.'
  },
  {
    id: 'liaison',
    category: 'Mots de liaison',
    title: 'Mots de Liaison',
    icon: '🔗',
    region: 'Iɣil',
    requiredLevel: 3,
    npcName: "Ameskar (L'Écrivain)",
    desc: 'Conjonctions, petits mots connecteurs et articulations de phrases.'
  },
  {
    id: 'double_pronom',
    category: 'Double Pronominalisation',
    title: 'Double Pronominalisation',
    icon: '🔀',
    region: 'Iɣil',
    requiredLevel: 3,
    npcName: 'Bab n Tajerrumt (Le Sage Grammairien)',
    desc: 'Pronoms simples COD/COI (Ḥemmleɣ-t, Fkiɣ-as, Ini-yas...) et affixes combinés (Efk-iyi-t, Fkiɣ-as-t, Ad as-t-iniɣ...).'
  },

  // Niveau 4 - Ijduden
  {
    id: 'couleurs',
    category: 'Couleurs',
    title: 'Couleurs & Teintes',
    icon: '🎨',
    region: 'Ijduden',
    requiredLevel: 4,
    npcName: 'Tazeṭṭaṭ (La Tisserande)',
    desc: 'Nuances des tapisseries traditionnelles et couleurs vives.'
  },
  {
    id: 'temps',
    category: 'Le Temps',
    title: 'Le Fil du Temps',
    icon: '⏳',
    region: 'Ijduden',
    requiredLevel: 4,
    npcName: 'Amɣar (Le Juge)',
    desc: 'Heures, saisons, jours et repères temporels.'
  }
];

export function getChallengeByCategory(categoryName: string): ChallengeItem | undefined {
  if (!categoryName || categoryName === 'TOUS' || categoryName === 'FAVORIS' || categoryName === 'SINGULIER_PLURIEL') {
    return undefined;
  }
  const norm = categoryName.toLowerCase().trim();
  const found = CHALLENGES_LIST.find((c) => c.category.toLowerCase().trim() === norm);
  if (found) return found;

  return {
    id: `custom_cat_${norm.replace(/[^a-z0-9]/g, '_')}`,
    category: categoryName,
    title: categoryName,
    icon: '🎯',
    region: 'Amawal',
    requiredLevel: 0,
    npcName: 'Amusnaw (Dictionnaire)',
    desc: `Quizz et entraînement sur le vocabulaire de la catégorie ${categoryName}.`
  };
}
